let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iHx0h")).then(() => parcelRequire('h8Ntk'));